import OwnerSubHeader from "@/components/OwnerSubHeader";
import InspectionBuilder from "@/components/InspectionBuilder";

export default function InspectionBuilderPage() {
  return (
    <div className="space-y-5" data-testid="inspection-builder-page">
      <OwnerSubHeader
        title="Inspection Builder"
        subtitle="Design checks · Expert Builder"
      />
      <InspectionBuilder />
    </div>
  );
}
